import { Metrics } from '../../../../../constants/Dashboards'
import { EventSpace2ActionTypes } from '../../../../../actions/dashboards'
import buildAsyncStatReducer from '../../asyncStatReducer'

/**
 * Event Space 2 Content Top
 */
const EventSpace2ContentTop = buildAsyncStatReducer({
  key: Metrics.EVENTSPACE2_CONTENT_TOP,
  types: EventSpace2ActionTypes.DASHBOARD_EVENTSPACE2_CONTENT_TOP,
  transform: (state, { payload }) => {
    const { link, count } = payload[0] || {}
    return { link, count }
  },
})

export default EventSpace2ContentTop